// DWG reader: the file is converted to DXF on the GISS server (LibreDWG runs only there, GPL software is
// not shipped with the app) and then read with the app's own DXF parser. Needs internet; blocked in KRITIS mode.
import { parseDxf } from './dxf';
import { licToken } from './license';
import { kritisOn } from './policy';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/cad/dwg2dxf`;
const UNIT_M = { 1: 0.0254, 2: 0.3048, 4: 0.001, 5: 0.01, 6: 1, 7: 1000 };

export async function parseDwg(buf) {
  if (!/^AC\d{4}/.test(String.fromCharCode(...buf.slice(0, 6)))) throw new Error('dwg');
  if (kritisOn()) throw new Error('dwgKritis');
  if (!navigator.onLine) throw new Error('dwgNet');
  let tok;
  try { tok = await licToken(); } catch { throw new Error('dwgKritis'); }
  if (!tok) throw new Error('dwgLic');
  const fd = new FormData();
  fd.append('file', new Blob([buf]), 'plan.dwg');
  let res;
  try { res = await fetch(API, { method: 'POST', headers: { 'X-License-Token': tok }, body: fd }); } catch { throw new Error('dwgNet'); }
  if (res.status === 403) throw new Error('dwgKritis');
  if (res.status === 402) throw new Error('dwgLic');
  if (!res.ok) throw new Error('dwg');
  const dxf = await res.text();
  const ents = parseDxf(dxf);
  if (!ents.length) throw new Error('dwg');
  const u = dxf.match(/\$INSUNITS\s*\r?\n\s*70\s*\r?\n\s*(\d+)/);
  return { ents, unit: UNIT_M[u?.[1]] || 1 };
}
